import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { DropzoneDialog } from 'material-ui-dropzone'

import { ProfileImageEditDialog } from 'src/components/Dialog'

interface AvatarUploadProps {
  open: boolean
  upload: (file: File) => Promise<null>
  onSave: () => void
  handleClose: () => void
}

export const AvatarUpload = (props: AvatarUploadProps) => {
  const { open, upload, onSave, handleClose } = props
  const [dropzoneOpen, setDropzoneOpen] = useState(false)
  const [editOpen, setEditOpen] = useState(false)
  const [file, setFile] = useState<File | undefined>(undefined)
  const [image, setImage] = useState<string | undefined>(undefined)
  const onImageSelect = (files: File[]) => {
    setFile(files[0])
    setDropzoneOpen(false)
    setEditOpen(true)
  }
  const { isLoading: imageLoading, mutate: uploadAvatar } = useMutation(upload, {
    onSuccess: () => {
      onSave()
      setEditOpen(false)
    },
  })
  const onCrop = async (croppedPicture: string) => {
    setImage(croppedPicture)
  }
  const onImageSave = () => {
    if (!imageLoading && image) {
      const file = dataURLtoFile(image, 'avatar.png')
      uploadAvatar(file)
    }
  }
  const dataURLtoFile = (dataurl: string, filename: string) => {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)![1]
    const bstr = atob(arr[1])
    const u8arr = new Uint8Array(bstr.length)

    for (let i = 0; i < bstr.length; i += 1) {
      u8arr[i] = bstr.charCodeAt(i)
    }

    return new File([u8arr], filename, { type: mime })
  }

  useEffect(() => {
    setDropzoneOpen(open)
  }, [setDropzoneOpen, open])

  return (
    <>
      <DropzoneDialog
        open={open && dropzoneOpen}
        onSave={onImageSelect}
        showPreviews={true}
        filesLimit={1}
        maxFileSize={5000000}
        submitButtonText="Select"
        onClose={() => {
          setDropzoneOpen(false)
          handleClose()
        }}
      />
      {!!file && (
        <ProfileImageEditDialog
          image={file}
          open={!!file && open && editOpen}
          handleClose={() => {
            setEditOpen(false)
            handleClose()
          }}
          onCrop={onCrop}
          onSave={onImageSave}
        />
      )}
    </>
  )
}
